<template>
  <EntrustFlow flow-model="SelfSendEntrustFlow" />
</template>

<script>
import EntrustFlow from './EntrustFlow.vue'

export default {
  name: 'SelfSendEntrustFlow',
  components: { EntrustFlow }
}
</script>
